import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import {
  FormControl,
  FormLabel,
  FormHelperText,
  Lists,
  Grid,
  Avatar,
  AvatarGroup,
  OverflowWrapper
} from '@fedsim/components'
import { SPACING } from '@fedsim/constants'
import { groupBy, getId, partition } from '@fedsim/helpers'

import { useChampionships } from 'contexts/Championship/hooks'
import { useWrestlers } from 'contexts/Wrestler'
import { useBrands } from 'contexts/Brand'
import { useShows } from 'contexts/Show'
import { useSegments } from 'contexts/Segment'

import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown'
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined'

import { Add, Delete } from 'icons'

export const groupTeams = (items = [], simulated = false) => {
  if (simulated) {
    return groupBy(items, 'groupId')
  } else {
    const teams =
      items.length > 0 ? groupBy(items, 'groupId') : { [getId()]: [] }

    return Object.assign({}, teams, { [getId()]: [] })
  }
}

export function InnerFormLists({
  collection = [],
  values = [],
  label = '',
  onChange,
  groupName = 'Wrestler'
}) {
  const split = partition(collection, item => values?.includes(item.id))
  const [expanded, setExpanded] = useState(false)
  const expandedHandler = () => setExpanded(!expanded)
  const ExpandIcon = !expanded
    ? ExpandCircleDownIcon
    : ExpandCircleDownOutlinedIcon
  const onRemove = id => {
    const newIds = [...values.filter(itemId => itemId !== id)]

    onChange(newIds)
  }
  const onAdd = id => {
    const newIds = [...values, id]

    onChange(newIds)
  }
  const addActions = [
    {
      title: 'Select',
      Icon: Add,
      color: 'success',
      onClick: ({ id }) => onAdd(id)
    }
  ]
  const removeActions = [
    {
      title: 'Remove',
      Icon: Delete,
      color: 'error',
      onClick: ({ id }) => onRemove(id)
    }
  ]
  return (
    <>
      <FormLabel>
        {label} <ExpandIcon onClick={expandedHandler} />
      </FormLabel>
      {split?.[0].length > 0 && (
        <Lists
          defaultListType='list'
          listTypeToggle={false}
          searchEnabled={false}
          groupName={groupName}
          collection={split[0]}
          actions={removeActions}
        />
      )}
      {expanded && (
        <>
          <OverflowWrapper>
            <Lists
              defaultListType='list'
              listTypeToggle={false}
              actions={addActions}
              groupName={groupName}
              collection={split[1]}
            />
          </OverflowWrapper>
        </>
      )}
    </>
  )
}

export const FormLists = ({
  options = [],
  name = '',
  label = '',
  control,
  groupName = 'Wrestler'
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value = [] }, fieldState: { error } }) => {
        return (
          <>
            {error && <FormHelperText>{error.message}</FormHelperText>}
            <FormControl fullWidth>
              <InnerFormLists
                label={label}
                collection={options}
                values={value}
                onChange={onChange}
                groupName={groupName}
              />
            </FormControl>
          </>
        )
      }}
    />
  )
}

export const FormChampionshipList = props => {
  const { imported } = useChampionships()

  return <FormLists options={imported} groupName='Championship' {...props} />
}

export const FormWrestlerList = props => {
  const { imported } = useWrestlers()

  return <FormLists options={imported} groupName='Wrestler' {...props} />
}

export const FormBrandList = props => {
  const { imported } = useBrands()

  return <FormLists options={imported} groupName='Brand' {...props} />
}

export const FormSegmentList = props => {
  const { imported } = useSegments()

  return <FormLists options={imported} groupName='Segment' {...props} />
}

export const FormShowList = props => {
  const { imported } = useShows()

  return <FormLists options={imported} groupName='Show' {...props} />
}

export function FormTeams({
  name = '',
  label = '',
  control,
  groupName = 'Wrestler'
}) {
  const { imported: wrestlers } = useWrestlers()

  return (
    <>
      {label}
      <Grid container spacing={SPACING}>
        <Controller
          name={name}
          control={control}
          render={({
            field: {
              onChange
              // value = []
            },
            fieldState: { error }
          }) => {
            const value = [['charlotte-flair', 'becky-lynch'], ['goldberg']]
            const mappedTeams = value.map(ids => {
              return ids.map(id => {
                const { name, image } = wrestlers.find(
                  wrestler => wrestler.id === id
                )

                return {
                  id,
                  name,
                  image
                }
              })
            })

            return mappedTeams.map((wrestlers, index) => (
              <Grid key={index} item>
                <AvatarGroup>
                  {wrestlers.map(wrestler => (
                    <Avatar key={wrestler.id} src={wrestler?.image} />
                  ))}
                </AvatarGroup>
                <InnerFormLists
                  label={`Team ${index + 1}`}
                  collection={wrestlers}
                  values={value[index]}
                  onChange={onChange}
                  groupName={groupName}
                />
              </Grid>
            ))
          }}
        />
      </Grid>
    </>
  )
}
